/**
 * @param {number} seconds
 * @returns {string}
 */
export function formatTime(seconds) {
  if (!isFinite(seconds) || seconds < 0) {
    return "0:00";
  }
  var s = Math.floor(seconds % 60);
  var m = Math.floor((seconds / 60) % 60);
  var h = Math.floor(seconds / 3600);
  var pad = function (n) {
    return n < 10 ? "0" + n : String(n);
  };
  if (h > 0) {
    return h + ":" + pad(m) + ":" + pad(s);
  }
  return m + ":" + pad(s);
}

export default { formatTime: formatTime };
